import md5 from 'md5'
import { isArray } from 'lodash'
import moment from 'moment'

export function getCustomersByWorkspaceSlug (state, slug) {
  return state.customers[slug]
}

export function getCustomerByWorkspaceSlug (state, slug) {
  return state.customer[slug]
}

export function getCustomersDataByWorkspaceSlug (state, slug) {
  const customers = getCustomersByWorkspaceSlug(state, slug) || {}
  return transformCustomerData(customers.data || [])
}

export function getCustomerDataByWorkspaceSlug (state, slug) {
  const customer = getCustomerByWorkspaceSlug(state, slug) || {}
  return transform(customer.data)
}

export function getCustomersCursorByWorkspaceSlug (state, slug) {
  const customers = getCustomersByWorkspaceSlug(state, slug) || {}
  return customers.cursor || {}
}

export function getCustomersRequestByWorkspaceSlug (state, slug) {
  const customers = getCustomersByWorkspaceSlug(state, slug) || {}
  return {
    isRequesting: customers.isRequesting,
    didRequestFail: customers.didRequestFail
  }
}

export function getCustomerRequestByWorkspaceSlug (state, slug) {
  const customers = getCustomerByWorkspaceSlug(state, slug) || {}
  return {
    isRequesting: customers.isRequesting,
    didRequestFail: customers.didRequestFail
  }
}

export function getCustomersSearchResultByWorkspaceSlug (state, slug) {
  const customers = getCustomersByWorkspaceSlug(state, slug) || {}
  const searchResult = customers.searchResult || {}
  return transformCustomerData(searchResult.data || [])
}

export function getCustomersSearchRequest (state, slug) {
  const customers = getCustomersByWorkspaceSlug(state, slug) || {}
  const searchResult = customers.searchResult || {}
  return {
    isRequesting: searchResult.isRequesting,
    didRequestFail: searchResult.didRequestFail
  }
}

export function getMatchingTraits (state, slug) {
  const searchTerm = state.application.customers.traitSearchTerm.toLowerCase()
  const customerData = getCustomerDataByWorkspaceSlug(state, slug)
  const traits = customerData.properties
  const matchingTraits = {}

  Object.keys(traits).filter(t => {
    const isMatch = matchesSearch(t, traits[t], searchTerm)
    if (isMatch) {
      matchingTraits[t] = traits[t]
    }
  })

  return matchingTraits
}

export function getMatchingEvents (state, slug) {
  const searchTerm = state.application.customers.eventSearchTerm.toLowerCase()
  const eventFilter = state.application.customers.eventFilter.toLowerCase()
  const customerData = getCustomerDataByWorkspaceSlug(state, slug)
  const events = customerData.events
  const matchingEvents = []

  events.filter(event => {
    const isFilterMatch = matchesFilter(event.type, eventFilter)
    const isSearchMatch = matchesSearch(event.event, event.timeAgo, searchTerm)
    if (isFilterMatch && isSearchMatch) {
      matchingEvents.push(event)
    }
  })

  return matchingEvents
}

function matchesFilter (eventType, eventFilter) {
  if (!eventFilter || eventFilter === 'all') return true
  if (eventFilter === 'page') return eventType === 'page'
  if (eventFilter === 'events') return true
}

/**
 * Check if `key` or `value` matches the `search` filter.
 */

function matchesSearch (key = '', value = '', search) {
  if (String(key).toLowerCase().match(search)) {
    return true
  }

  if (String(value).toLowerCase().match(search)) {
    return true
  }

  return false
}

function transformCustomerData (customers) {
  return customers.map((customer) => transform(customer))
}

function transform (customer) {
  const user = defaults(customer)

  if (!user.properties.name) {
    if (user.properties.first_name && user.properties.last_name) {
      user.properties.name = user.properties.first_name + ' ' + user.properties.last_name
    } else if (user.properties.email) {
      user.properties.name = user.properties.email.split('@')[0].trim()
    } else {
      user.properties.name = 'Anonymous User'
    }
  }

  if (!user.properties.company) {
    user.properties.company = user.properties.company_name ||
      user.properties.reveal_company_name ||
      user.properties.reveal_name ||
      user.properties.reveal_legalName ||
      user.properties.linkedin_company ||
      user.properties.facebook_company ||
      user.properties.twitter_company ||
      user.properties.github_company
  }

  if (!user.properties.avatar && user.properties.email) {
    user.properties.avatar = getUserAvatar(user.properties.email)
  }

  user.properties.twitter = user.properties.twitter || user.properties.reveal_twitter_handle
  user.properties.linkedin = user.properties.linkedin || user.properties.reveal_linkedin_handle

  user.properties.title = user.properties.title || user.properties.role

  user.properties.location = user.properties.reveal_location ||
    user.properties.reveal_twitter_location ||
    user.properties.reveal_geo_state ||
    user.properties.reveal_geo_city ||
    user.properties.reveal_geo_stateCode ||
    user.properties.reveal_geo_countryCode ||
    user.properties.country ||
    user.properties.city ||
    user.properties.reveal_timeZone ||
    user.properties.ip

  user.events = transformEventList(user.events)

  return user
}

function defaults (record = {}) {
  const user = {
    externalIds: record.external_ids || {},
    aggregates: record.aggregates || {},
    segmentId: record.segment_id || '',
    metadata: record.metadata || {},
    properties: {},
    events: []
  }

  let properties = record.properties || []
  // paginated
  if (properties.data) {
    properties = record.properties.data
  }

  properties.forEach(({ key, value }) => {
    user.properties[key] = value
  })

  let events = record.events || []
  // paginated
  if (events.data) {
    user.events = events.data
  }

  let aggregates = record.aggregates || []
  // paginated
  if (aggregates.data) {
    user.aggregates = aggregates.data
  }

  return user
}

function transformEventList (events) {
  if (!events || !isArray(events)) {
    if (events && events.data) {
      events = events.data
    } else {
      return []
    }
  }

  const transformedEvents = events.map(event => {
    event.timeAgo = moment(event.timestamp)
      .format('dddd, MMMM Do YYYY, h:mm a')
      .toString()

    return event
  })
  const filteredEvents = transformedEvents.filter(e => {
    return e.event !== 'Experiment Viewed'
  })

  return filteredEvents
}

function getUserAvatar (email) {
  return `https://secure.gravatar.com/avatar/${email && md5(email)}.jpg?s=80&d=blank`
}



// WEBPACK FOOTER //
// ./selectors/customers.js